var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credito") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credito"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,47.5 C36.9786916,47.5 47.5,36.9786916 47.5,24 C47.5,11.0213084 36.9786916,0.5 24,0.5 C11.0213084,0.5 0.5,11.0213084 0.5,24 C0.5,36.9786916 11.0213084,47.5 24,47.5 Z",
    id: "Oval",
    stroke: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 24.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5 C0,0.223637961 0.225138652,0 0.5,0 L3.5,0 C3.77683817,0 4,0.221660808 4,0.5 C4,0.775922671 3.77442205,1 3.5,1 L0.5,1 C0.223161825,1 0,0.777899824 0,0.5",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0.5 C5,0.223637961 5.22513865,0 5.5,0 L8.5,0 C8.77639888,0 9,0.221660808 9,0.5 C9,0.775922671 8.77442205,1 8.5,1 L5.5,1 C5.22316183,1 5,0.777899824 5,0.5",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0.5 C10,0.223637961 10.2255779,0 10.5,0 L13.5,0 C13.7763989,0 14,0.221660808 14,0.5 C14,0.775922671 13.7744221,1 13.5,1 L10.5,1 C10.2231618,1 10,0.777899824 10,0.5",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0.5 C16,0.223637961 16.2255779,0 16.5,0 L19.5,0 C19.7768382,0 20,0.221660808 20,0.5 C20,0.775922671 19.7744221,1 19.5,1 L16.5,1 C16.2231618,1 16,0.777899824 16,0.5",
    id: "Fill-13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icono_tc",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-51",
    opacity: 0.3,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.584,0 L22.416,0 L22.416,0 C23.290819,-1.71469244e-15 24,0.709180956 24,1.584 L24,14.416 L24,14.416 C24,15.290819 23.290819,16 22.416,16 L1.584,16 L1.584,16 C0.709180956,16 -1.14910171e-16,15.290819 -2.22044605e-16,14.416 L0,1.584 L2.22044605e-16,1.584 C1.14910171e-16,0.709180956 0.709180956,8.26835466e-16 1.584,6.66133815e-16 Z",
    id: "Rectangle-path",
    fill: "#5697FA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#0864EE",
    x: 0,
    y: 3,
    width: 24,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 2,
    y: 7,
    width: 20,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#0864EE",
    x: 2,
    y: 13,
    width: 10,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#0864EE",
    x: 2,
    y: 11,
    width: 15,
    height: 1,
    rx: 0.5
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.727f4b0cba95a4a72294554d3192a6c8.svg";
export { ForwardRef as ReactComponent };